<script>
import { AbcFloatingContainer } from "@ordbogen-npm/abc-dsk";
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

import IconCookie from "@/components/icons/IconCookie.vue";
import IconPrivacy from "@/components/icons/IconPrivacy.vue";
import IconTerms from "@/components/icons/IconTerms.vue";
import Cookie from "@/components/policies/Cookie.vue";
import Privacy from "@/components/policies/Privacy.vue";
import TradeTermsBusiness from "@/components/policies/TradeTermsBusiness.vue";

export default defineComponent({
  name: "PoliciesView",
  components: {
    Cookie,
    Privacy,
    TradeTermsBusiness,
    AbcFloatingContainer,
    IconCookie,
    IconPrivacy,
    IconTerms,
    RouterLink
  },
  data() {
    return {
      cookie: "",
      privacy: ""
    };
  },
  computed: {
    component() {
      return ["cookie", "privacy", "tradeTermsBusiness"].some(
        (page) => this.$route.params?.policy === page
      )
        ? this.$route.params.policy
        : "cookie";
    }
  }
});
</script>

<template>
  <AbcFloatingContainer with-header class="container policies mb-5">
    <main class="container policies">
      <div class="row">
        <div class="col-lg-4 policies__column policies__menu">
          <div class="d-flex flex-wrap">
            <RouterLink
              :to="{ name: 'policies', params: { policy: 'cookie' } }"
              class="policies__link"
              :class="{ 'policies__link--active': component === 'cookie' }"
            >
              <IconCookie class="policies__icon" />
              {{ $t(`policies.cookiePolicy`) }}
            </RouterLink>

            <RouterLink
              :to="{ name: 'policies', params: { policy: 'privacy' } }"
              class="policies__link"
              :class="{ 'policies__link--active': component === 'privacy' }"
            >
              <IconPrivacy class="policies__icon" />
              {{ $t(`policies.privacyPolicy`) }}
            </RouterLink>

            <RouterLink
              :to="{ name: 'policies', params: { policy: 'tradeTermsBusiness' } }"
              class="policies__link"
              :class="{ 'policies__link--active': component === 'tradeTermsBusiness' }"
            >
              <IconTerms class="policies__icon" />
              {{ $t(`policies.tradeTermsBusiness`) }}
            </RouterLink>
          </div>
        </div>
        <Component :is="component" />
      </div>
    </main>
  </AbcFloatingContainer>
</template>
